/* eslint-disable @sailor/base-no-side-effects-in-default-params */
/* eslint-disable multiline-comment-style */
import { getI18nParams } from './i18n'

const getOwlReportInfo = () => ({
  entInfo: '',
  i18n: getI18nParams(),
  unionid: window.Owl?.cfgManager.getExtension('unionId'),
  os: window.Owl?.cfgManager.getExtension().os || '',
})

//  方便判断页面多久未刷新，页面停留时间
// owl小写,函数方法，使用方式owl('fnName', xxx)
// Owl大写,对象，提供addError，addLog，MetricManager等
// 境外owlSDK对应国内1.10.0以上版本
let metricInstance = null

/**
 * 自定义上报
 * https://km.sankuai.com/page/1291907878#id-addError
 * err 参数代表异常的基本信息，可选类型包括 String、Object 和 Error 实例：
 *  当类型为 String 时，使用字符串内容作为异常名称，无堆栈信息
 *  当类型为 Object 时，要求对象有 name 和 msg 属性，并使用 name 作为异常名称，msg 作为异常堆栈
 *  当类型为 Error 实例时，将对 err 进行解析，使用 err 的 message 属性作为异常名称，stack 属性作为异常堆栈
 * opts |选填,为对象，代表异常的补充信息，可选属性包括 category、level、tags 和 combo：
 * {
 *  category 为 String 类型，表示异常分类，可选 jsError、ajaxError、resourceError 和自定义的业务异常，默认为 jsError
 *  level 为 String 类型，表示异常等级，可选 error、warn 和 info，默认为 error
 *  tags 为 Object 类型，表示异常的自定义信息
 *  combo 为 Boolean 类型，表示是否要和其他异常延时合并上报。默认不合并上报，combo 设置为 true 时合并上报
 * }
 */
export const owlAddError = (err, opts) => {
  try {
    if (window.Owl) {
      window.Owl.addError(err, { level: 'info', ...opts })
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('OWL 自定义上报异常：', e)
  }
}

/**
 * logString <String> |必填,日志内容，限一次1M。
 * logType <String> 可选 默认为'default'。
 * 日志类型。已支持'owl'、'redux'、'vuex'、'zaku'、'archer'、'mtgame'、'tracker'、'hotdog'。如需申请新的日志类型，请提TT联系Logan客服。
 * logLevel <String> 可选 日志级别，可支持'info'、'warn'、'error'。
 * tags <String | String[]> 可选 日志标签，可对日志打自定义标签，后续在日志高级查询中可根据标签筛选相关日志
 * https://km.sankuai.com/page/354806436
 * window.Owl('addLog', msg, type); // 1.10.0+ 版本
 */
export const owlAddLog = (msg, type, logLevel, tags) => {
  try {
    if (window.Owl) {
      // eslint-disable-next-line @utiljs/utiljs/type-typeof-limit
      typeof msg === 'object'
        ? window.Owl.addLog(JSON.stringify({ ...msg, ...getOwlReportInfo() }), type, logLevel, tags)
        : window.Owl.addLog(msg, type, logLevel, tags)
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('OWL addLog异常：', e)
  }
}

// 自定义指标上报
// name <String> |必填,指标名称
export const owlSetMetric = (name, value) => {
  try {
    if (!metricInstance) {
      metricInstance = window.Owl?.MetricManager()
    }
    metricInstance && metricInstance.setMetric && metricInstance.setMetric(name, value)
  } catch (error) {/* empty */}
}

// 自定义Tag上报
export const owlSetTags = (objDate = {}) => {
  try {
    if (!metricInstance) {
      metricInstance = window.Owl.MetricManager()
    }
    metricInstance && metricInstance.setTags && metricInstance.setTags(objDate)
  } catch (error) {/* empty */}
}

export const owlReportMetricsWeb = (valuesDic = {}, tagsDic = {}, { extraString, owlProjectName } = {}) => {
  let imetricInstance = metricInstance
  if (!imetricInstance) {
    imetricInstance = window.Owl.MetricManager()
  }
  if (owlProjectName && window.owl) {
    let newInst = window.owl('createInstance', {
      project: owlProjectName || 'com.sankuai.sailorfe.bp.exception',
    })
    imetricInstance = newInst && newInst.MetricManager()
  }
  const [metricName, metricValue] = Object.entries(valuesDic)[0] || []
  metricName && imetricInstance.setMetric(metricName, metricValue)
  imetricInstance.setTags(tagsDic)
  extraString && imetricInstance.setExtraData(extraString)
}

export const owlReportMetrics = (valuesDic = {}, tagsDic = {}, { extraString, owlProjectName } = {}) => {
  try {
    owlReportMetricsWeb(valuesDic, tagsDic, { extraString, owlProjectName })
  } catch (error) {
    console.log(error)
  }
}

// 递归获取该模块下的所有路由数量
const getAllPathLength = (routes) => {
  let length = 0
  for (const route of routes) {
    if (route.path && route.path !== '*') {
      length++
    }
    if (route.children) {
      length += getAllPathLength(route.children)
    }
  }
  return length
}


// 自定义上报，默认info级别，避免造成大面积告警
// err: 可为string | {name,msg}对象 | Error对象
// tags: Object, 自定义异常信息
// opts: 覆盖owlAddError配置
const gen = (category = 'jsError', level = 'info') => (
  err,
  tags = getOwlReportInfo() || {},
  opts = { level }
) =>
  owlAddError(err,
    {
      category,
      tags: { ...tags, ...getOwlReportInfo() },
      ...opts,
    },
  )

export const owlAddJsInfo = gen('jsError')
export const owlAddAjaxInfo = gen('ajaxError')
export const owlAddResourceInfo = gen('resourceError')

export const owlAddJsError = gen('jsError', 'error')
export const owlAddAjaxError = gen('ajaxError', 'error')
export const owlAddResourceError = gen('resourceError', 'error')
